import "./Dashboard.css";
import React, { useEffect, useState } from "react";
import JobCard from "../../Jobcard/JobCard";
import NavBar from "../../Navbar";
import { useSelector } from "react-redux";
import { get_skills, list_jobs, search_jobs, del_jobs, apply_job, view_applications } from "../../../utilities/apis";
import { useDispatch } from "react-redux";
import { setJobArray } from "../../../app/state/userSlice";
import ModalPg from "../../ModalPg/ModalPg";


const Dashboard = () => {
  const [jobList, setJobLists] = useState([]);

  const [searchQuery, setSearchQuery] = useState({ searchQuery: "" });
  
  const dispatch = useDispatch();
  const [personName, setPersonName] = useState("");
  // console.log(userName);

  const selectUserRole = useSelector((state) => state.user.userRole);
  const selectUserID = useSelector((state) => state.user.userID);
  const isEmployer = useSelector((state) => state.user.userRole) === "employer" ? true : false;
  const [isModalOpen,setIsModalOpen] = useState(false);
  const [appliedJob,setApplyJob] = useState("")
  const [applyJobId,setApplyJobId] = useState(null);
  // const userName = useSelector((state) => state.user.name);

  useEffect(() => {
    callJobAPI();
  }, []);

  useEffect(()=>{
    console.log("Jobs Updated")
  },[jobList])

  const callJobAPI = async () => {
    try {
      
      const getSkillsRes = await get_skills({
        user_id: selectUserID,
      });
      // if (getSkillsRes.success && isEmployer){ setPersonName(getSkillsRes.person_name);
      //   console.log(`${personName}hii`);}

      setPersonName(getSkillsRes.person_name);
      console.log(`${personName}hi`);
      if (getSkillsRes.success && !isEmployer) {
       
        const searchJobString = getSkillsRes.req_skills.map(skill => skill.trim()).join(",");
        setSearchQuery({ searchQuery: searchJobString });
        
        const jobFromSkillsRes = await search_jobs({
          user_id:selectUserID,
          user_role:selectUserRole,
          keywords:searchJobString
      });
        setJobLists(jobFromSkillsRes);
        dispatch(setJobArray(jobFromSkillsRes));
      } else {

        const jobRes = await list_jobs({
          user_role:selectUserRole,
          user_id: selectUserID,
        });
        setJobLists(jobRes);
        dispatch(setJobArray(jobRes));
      }
    } catch (error) {
      console.error("Error fetching skills: ", error);
      try{
        const jobRes = await list_jobs({
          user_role:selectUserRole,
          user_id: selectUserID,
        });;
        setJobLists(jobRes);
        dispatch(setJobArray(jobRes));

      }catch(error){
        alert(error)
      }
     
    }
  };

  async function applyJob(job_id){
    try{
      const applyRes = await apply_job({
        user_id: selectUserID,
        job_id: job_id,
      });
      if (applyRes.success) {
        handleApplyState(job_id);
      }

    }catch(error){
      console.log("Error while applying for job: ",error);
    }
  }
        
       
  
  
  function handleNoClk (){
    setIsModalOpen(false);
  }

  function handleYesClk(){
    setIsModalOpen(false)
    applyJob(applyJobId);
  }

  const handleSearch = (e) => {
    setSearchQuery((prevState) => ({
      ...prevState,
      searchQuery: e.target.value,
    }));
  };

  //function to update the applied button.
  const handleApplyState = (jobId) => {
    const updatedJobs = jobList.map(job => 
      job.job_id === jobId ? { ...job, applied_status: true } : job
    );
    setJobLists(updatedJobs);
  };

  const setJobTitle = (jobTitle,jobId) => {
    setApplyJob(jobTitle);
    setApplyJobId(jobId)
    setIsModalOpen(true);
  }

  const onSearchClick = async (e) => {
    e.preventDefault();
    try {
      if (searchQuery.searchQuery.length > 2) {
        const searchRes = await search_jobs({
          user_id:selectUserID,
          user_role:selectUserRole,
          keywords:searchQuery.searchQuery
      });
        console.log("JOBS: ", searchRes);
        setJobLists(searchRes);
        dispatch(setJobArray(searchRes));
      } else {
        alert("Enter atleast 3 characters.");
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const deleteJobAndUpdateState = async (jobId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this job?");
    if (confirmDelete) {
      try {
        const deleteRes = await del_jobs(jobId,{user_id:selectUserID});
        if (!deleteRes) {
          alert("Failed to delete job. No response from server.");
          return;
        }
        console.log("DeleteRes: ",deleteRes)
        if (deleteRes.success && deleteRes.remaining_jobs) {
          console.log(deleteRes.remaining_jobs,"Remaining");
          setJobLists(deleteRes.remaining_jobs)
        } else {
          // Handle cases where the deletion is reported as unsuccessful or the format is unexpected
          console.error("Job deletion failed or response was in unexpected format:", deleteRes);
          alert("Failed to delete job. Please try again.");
        }
      } catch (error) {
        console.error("Failed to delete job due to an error:", error);
        alert("An error occurred while deleting the job. Please check your network connection and try again.");
      }
    }
  };

  const searchJobs = jobList.map((job, index) => {
    return <JobCard jobDetails={job} onDelete={() => deleteJobAndUpdateState(job.job_id)} setJobTitle={setJobTitle}/>;
  });


  return (
    <div className='enc'>
      <NavBar postJobFlag={isEmployer} logOutFlag={true} username={personName} />
      <div>
        <ModalPg isOpen={isModalOpen} handleNoClk={handleNoClk} handleYesClk={handleYesClk} description={`Do you want to Apply for ${appliedJob}?`}></ModalPg>
      </div>
      <section className='container-fluid'>
        <section className='row justify-content-center container-home'>
          <div className='text-center pt-4 mt-5'>
            <h2 className='fydj'>
              {isEmployer ? "Employer" : "Find Your Dream"} <span className='text-primary'>{isEmployer ? "Dashboard" : "Job"}</span> {isEmployer ? " " : "Now"}
              <h5>{isEmployer ? "Find the perfect solution for all your hiring needs effortlessly." : "Browse open jobs in different job categories"}</h5>
            </h2>
          </div>
          <form className='d-flex searchAndbtn' role='search'>
            <input
              className='searchBar form-control dash-searchBar'
              type='search'
              placeholder='&#128269;'
              // value={searchQuery.searchQuery}
              aria-label='Search'
              style={{ fontSize: "1.1em" }}
              onChange={handleSearch}
            />
            <button onClick={onSearchClick} className='btn btn-primary searchBtn' type='submit'>
              Search
            </button>
          </form>
        </section>
        <div className='row'>{searchJobs}</div>
      </section>
    </div>
  );
};


export default Dashboard;
